import styled from 'styled-components';
import { Typography, Paper, IconButton } from '@material-ui/core';


export const ContentContainer = styled.div`
  height: ${props => (props.minimized ? '0px' : '360px')};
  padding: ${props => (props.minimized ? '0px' : '16px')};
  overflow: auto;
  position: relative;
`;

export const Header = styled.div`
  display: flex;
  height: 40px;
  padding: 10px 16px;
  align-items: center;
  color: white;
  border-radius: 10px 10px 0% 0%;
  background-color: #537ccd;
`;

export const StyledTypography = styled(Typography)`
  color: white !important;
  font-weight: bold !important;
  margin-right: auto !important;
`;

export const Details = styled.span`
  opacity: 0.8;
  font-weight: normal;
`;

export const StyledPaper = styled(Paper)`
  border-top-left-radius: 10px !important;
  border-top-right-radius: 10px !important;
  position: relative ;
  left: calc(50% - 460px/2);
  width: ${props => (props.minimized ? '270px' : '460px')};
`;

export const StyledIconButton = styled(IconButton)`
  color: white !important;
  padding: 6px !important;
`;

export const FieldsContainer = styled.div`
  max-height: 280px;
  overflow: auto;
`;

export const ActionsContainer = styled.div`
  position: absolute;
  left: 0;
  bottom: 0;
  padding: inherit;
  width: 100%;
`;

